import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';

interface EntityLoaderOptions<T> {
  load(): Promise<T>;
  fallbackError?: string;
}

export class EntityLoader<T> {
  @observable private _value?: T = undefined;
  @observable private _isLoading = false;
  @observable private _error?: string = undefined;

  private _config: EntityLoaderOptions<T>;

  constructor(config: EntityLoaderOptions<T>) {
    this._config = config;

    makeObservable(this);
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get error() {
    return this._error;
  }

  @computed get value() {
    return this._value;
  }

  @action load = async () => {
    runInAction(() => {
      this._isLoading = true;
      this._error = undefined;
      this._value = undefined;
    });

    try {
      const response = await this._config.load();

      runInAction(() => {
        this._value = response;
      });
    } catch (e) {
      const fallback =
        this._config.fallbackError || 'Не удалось выполнить запрос';
      const error = e instanceof Error ? e.message : fallback;

      runInAction(() => {
        this._error = error;
      });
    }

    runInAction(() => {
      this._isLoading = false;
    });
  };
}
